import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar";
import Banner from "../Section/Banner/banner";
import About from "../Section/About/about";
import New from "../Section/New/New.jsx";
import Newlivia from "../Section/NewLivia/Newlivia.jsx";
import Livia from "../Section/Livia/Livia.jsx";
import Aboutproduk from "../Section/AP/AP.jsx";
import Fasilitas from "../Section/Fasilitas/fasilitas.jsx";
import Produk from "../Section/Produk/produk.jsx";
import Ruko from "../Section/Ruko/ruko.jsx";
import Surrounding from "../Section/surrounding/Surrounding.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footer/footer.jsx";
import Altara from "../Section/Student/Student.jsx";
import Scrolltohashelement from "../Pages/ScrollToHashElement";
import tombol from "../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <About />
      <Newlivia />
      <Livia />
      <New />
      <Altara />
      <Aboutproduk />
      <Fasilitas />
      <Produk />
      <Ruko />
      <Surrounding />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
